/// THIS FILE IS AUTOGENERATED!!! DO NOT EDIT MANUALLY!!!
/// INSTEAD, USE A VITE PLUGIN OR RUN `php artisan bridge:generate:enumerations` COMMAND.

export const DiscountMode = {
  FIXED: 'FIXED',
  PERCENT: 'PERCENT',
} as const;

export type DiscountMode = typeof DiscountMode[keyof typeof DiscountMode];
